import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Tenant } from 'src/app/shared/models/tenant';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { AppConfig } from 'src/app/shared/models/config/appConfig';

@Injectable({ providedIn: 'root' })
export class PortalInitializationService {
  public static readonly EnvironmentSettingsLocation: string = '/assets/config/environment.json';

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
    private router: Router
  ) {}

  get baseApiUrl(): string {
    return this.appConfigService.baseApiUrl;
  }

  load(): Promise<AppConfigService> {
    return this.http
      .get(PortalInitializationService.EnvironmentSettingsLocation + '?t=' + new Date().getTime())
      .toPromise()
      .then((res) => {
        this.appConfigService.config = AppConfig.parse(res);
      })
      .then(() => {
        return this.http.get(this.baseApiUrl.concat('tenants/current')).toPromise();
      })
      .then((res) => {
        this.appConfigService.tenant = Tenant.parse(res);
        this.appConfigService.initialized = true;
        this.appConfigService.loadError = false;
        return this.appConfigService;
      })
      .catch((error: any) => {
        this.appConfigService.initialized = false;
        this.appConfigService.loadError = true;
        this.router.navigate(['/maintenance-mode'], { skipLocationChange: true });
        return this.appConfigService;
      });
  }
}
